<template>
  <div class="comment__audit-compare-content">
    <span>Story Points:</span>
    <StoryPoint
      :value="beforeStoryPoints"
      class="is-opacity"
    />
    <icon
      data="@icon/arrow-to.svg"
      :fill="true"
      width="var(--icon-24)"
      height="var(--icon-24)"
      color="var(--monochrome05to04)"
    />
    <StoryPoint :value="afterStoryPoints" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import StoryPoint from "@/components/StoryPoint/index.vue"

import { Comment } from "@/models"

const props = defineProps<{
  comment: Comment
}>()

const beforeStoryPoints = computed(() => props.comment.before?.storyPoints ?? null)
const afterStoryPoints = computed(() => props.comment.after?.storyPoints ?? null)
</script>
